import { Component, inject, Input } from "@angular/core";
import { WhiteLabelConfigService } from "../../../../../../../../../shared/src/lib/services/white-label-config.service";
import { Market } from "../../../../../../../../../shared/src/lib/types/bet.type";
import { DecimalPipe } from "@angular/common";

@Component({
  selector: "app-bet-config",
  imports: [DecimalPipe],
  templateUrl: "./bet-config.component.html",
  styleUrl: "./bet-config.component.scss",
})
export class BetConfigComponent {
  @Input({ required: true }) market!: Market;
  whitelabelConfig = inject(WhiteLabelConfigService);

  get maxBetSize() {
    if (!this.whitelabelConfig?.betConfig || !this.market?.eventType?.id) return null;
    return this.whitelabelConfig.betConfig[this.market.eventType.id]?.max_bet_size || null;
  }

  get minBetSize() {
    if (!this.whitelabelConfig?.betConfig || !this.market?.eventType?.id) return null;
    return this.whitelabelConfig.betConfig[this.market.eventType.id]?.min_bet_size || null;
  }
}
